export default __webpack_public_path__ + "static/media/calender_inactive.ef82e557.svg";